module.exports = __webpack_public_path__ + "static/loreal-f107349210d2f64fcf3c628a7301bf04.jpg";